import React from "react";
import Select from "react-select";

const details = (template) => ({
  reviewType: template.reviewTypeName || "Not configured",
  workTypes: template.workTypeNames?.join(", ") || "All work types",
  clientTypes: template.clientTypeNames?.join(", ") || "All client types",
  industries: template.industryTypeNames?.join(", ") || "All industries",
});

export default function ReviewTemplateSelect({
  templates = [],
  value,
  onChange,
  ...props
}) {
  const options = templates.map((template) => ({
    value: String(template.id),
    label: template.name,
    template,
    ...details(template),
  }));
  return (
    <Select
      {...props}
      isSearchable
      options={options}
      value={options.find((option) => option.value === String(value)) || null}
      onChange={(option) => onChange(option?.template || null)}
      placeholder={props.placeholder || "Search and select review template"}
      noOptionsMessage={() => "No review templates found"}
      filterOption={({ data }, input) =>
        `${data.label} ${data.reviewType} ${data.workTypes} ${data.clientTypes} ${data.industries}`
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      formatOptionLabel={(option, { context }) =>
        context === "value" ? (
          option.label
        ) : (
          <div style={{ lineHeight: 1.5, padding: "4px 0" }}>
            <div style={{ fontWeight: 700, marginBottom: 5 }}>
              {option.label}
            </div>
            <div style={{ fontSize: 11 }}>
              <b>Review type:</b> {option.reviewType}
            </div>
            <div style={{ fontSize: 11 }}>
              <b>Work type:</b> {option.workTypes}
            </div>
            <div style={{ fontSize: 11 }}>
              <b>Client type:</b> {option.clientTypes}
            </div>
            <div style={{ fontSize: 11 }}>
              <b>Industry:</b> {option.industries}
            </div>
          </div>
        )
      }
    />
  );
}
